import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
  import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './Terms-Use.css';
import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
 import { NavLink } from "react-router-dom";





const TermsUse = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('Empower');
    const [openBioIndex, setOpenBioIndex] = useState(null);
      const [selectedMember, setSelectedMember] = useState(null);
        const [openIndex, setOpenIndex] = useState(null);
      const [directors, setDirectors] = useState([]);
        const [showAll, setShowAll] = useState(false);
       
  

  const closeBio = () => {
  setSelectedMember(null);
};  
 
  
const toggleBio = (index) => {
  setOpenBioIndex(prevIndex => (prevIndex === index ? null : index));
};

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
    const handleBioClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  
 

const navItems = [

  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
   { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

  return (
    <>


       {/* Header */}
             <header className="header">
                           <div className="nav-container">
                             <div className="logo">
                               <Link to="/">
                                 <img src="web.png" alt="PIR Logo" />
                               </Link>
                             </div>
                         
                             {/* Desktop Nav */}
                             <nav className="nav-links">
                                                                           {navItems.map((item, index) => (
                                                                             <div key={index} className="nav-item">
                                                                               <NavLink
                                                                                 to={item.path}
                                                                                 className={({ isActive }) =>
                                                                                   isActive ? "nav-button active" : "nav-button"
                                                                                 }
                                                                               >
                                                                                 {item.title}
                                                                               </NavLink>
                                                                             </div>
                                                                           ))}
                                                                         </nav>
                         
                             {/* Search + Title */}
                             <div className="search-language" style={{ position: "relative" }}>
                               <div
                                 style={{
                                   position: "absolute",
                                   top: "-19px",
                                   left: "16px",
                                   fontSize: "22px",
                                   color: "#FF6F00",
                                   fontFamily: "Mukta, sans-serif",
                                   whiteSpace: "nowrap",
                                   zIndex: 10,
                                   pointerEvents: "none",
                                 }}
                               >
                                 <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                               </div>
                         
                               <div className="pir-search-wrapper">{/* Search Bar */}</div>
                             </div>
                         
                             {/* Hamburger Toggle */}
                             <button
                               className="mobile-toggle"
                               onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                             >
                               ☰
                             </button>
                           </div>
                         
                           {/* Mobile Menu */}
                           {isMobileMenuOpen && (
                             <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                           {navItems.map((item, index) => (
                             <Link
                               key={index}
                               className="mobile-link"
                               to={item.path}
                               onClick={() => setMobileMenuOpen(false)}
                             >
                               {item.title}
                             </Link>
                           ))}
                         </div>
                           )}
                         </header>
   <section className="terms-container">
  <h1>📃 वापर अटी (Terms of Use)</h1>
  <p className="updated-date">अंतिम अद्यतन: २५ जुलै २०२५</p>
  <p>
    lokadhikar.in या वेबसाइटचा वापर करताना आपण खालील अटी व शर्ती मान्य करत आहात. कृपया या अटी काळजीपूर्वक वाचा.
    जर आपण या अटींशी असहमत असाल, तर कृपया वेबसाइटचा वापर करू नका.
  </p>

  <h2>1. वेबसाइटचा उद्देश</h2>
  <p>
    ही वेबसाइट महाराष्ट्र लोकाधिकार समितीच्या कार्याची माहिती, आंदोलनांचा इतिहास, फोटो/व्हिडिओ कलेक्शन, नोंदणी,
    जनजागृती आणि कायदेशीर सहकार्य यासाठी तयार करण्यात आलेली आहे.
  </p>

  <h2>2. वापरकर्ता आचारसंहिता</h2>
  <ul>
    <li>आपण कोणतीही खोटी, दिशाभूल करणारी किंवा चुकीची माहिती अपलोड करु नये.</li>
    <li>
      वेबसाइटचा वापर करताना कायद्याचे उल्लंघन, द्वेषपूर्ण भाषण, धमकी, धार्मिक/वर्गीय तेढ वाढवणारे मजकूर/फोटो/व्हिडिओ यांना
      मनाई आहे.
    </li>
    <li>
      आपण वेबसाइटवरील कोणत्याही माहितीचा अनधिकृत वापर, कॉपी-पेस्ट, पुनर्वितरण केल्यास संबंधित कायदेशीर कारवाई होऊ शकते.
    </li>
  </ul>

  <h2>3. मालकी हक्क</h2>
  <p>
    या वेबसाइटवरील सर्व माहिती, लोगो, फोटो, दस्तऐवज, मजकूर, डिझाईन, व्हिडिओ हे महाराष्ट्र लोकाधिकार समितीचे बौद्धिक
    मालमत्ता (Intellectual Property) आहेत. पूर्वपरवानगीशिवाय त्यांचा व्यावसायिक वापर, पुनर्प्रकाशन, वा वितरण करता येणार नाही.
  </p>

  <h2>4. लिंक व तृतीय-पक्ष सेवा</h2>
  <p>
    वेबसाइटवरून काही वेळा तृतीय-पक्ष साइट्स/सोशल मिडिया लिंक दिल्या जातात. त्या साइट्सवरील धोरणे, माहिती व कृतीस
    महाराष्ट्र लोकाधिकार समिती जबाबदार नाही. कृपया त्या साइट्सच्या अटी स्वतंत्रपणे वाचा.
  </p>

  <h2>5. जबाबदारी मर्यादा</h2>
  <p>
    वेबसाइटवरील माहिती सर्वसामान्य माहितीपुरती दिली जाते. ती कायदेशीर सल्ल्याचा पर्याय नाही. माहिती अचूक ठेवण्याचा आम्ही
    प्रयत्न करतो, मात्र प्रतिकूल परिणाम, तांत्रिक अडचणी, किंवा चुकीमुळे झालेल्या नुकसानासाठी आम्ही जबाबदार ठरणार नाही.
  </p>

  <h2>6. खाते नोंदणी आणि सुरक्षा</h2>
  <ul>
    <li>खाते तयार करताना योग्य माहिती द्या.</li>
    <li>आपले लॉगिन तपशील गोपनीय ठेवा.</li>
    <li>कोणत्याही प्रकारच्या फसवणुकीसाठी केलेल्या वापराबद्दल स्वतः जबाबदार असाल.</li>
  </ul>

  <h2>7. नियमबदलाचा अधिकार</h2>
  <p>
    महाराष्ट्र लोकाधिकार समितीला या अटी कोणत्याही वेळी बदलण्याचा, सुधारण्याचा, काढून टाकण्याचा अधिकार आहे. वापरकर्त्यांनी अटी
    वेळोवेळी तपासाव्यात.
  </p>

  <h2>8. कायदा व क्षेत्राधिकार</h2>
  <p>
    या अटी भारताच्या कायद्याअंतर्गत शासित आहेत. कोणत्याही वादविवादावर महाराष्ट्रातील संबंधित न्यायालयाचे क्षेत्राधिकार राहतील.
  </p>
</section>


        
    
       
 <footer className="pir-footer">
    <div className="footer-container">
      {/* Logo on the left */}
      <div className="footer-left">
        <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
      </div>

      {/* Center: Two columns of links */}
      <div className="footer-center">
        <div className="footer-links-columns">
          <ul className="footer-links">
            <li>
              <a href="/privacypolicy">
                <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
              </a>
            </li>
            <li>
              <a href="/signuppolicy">
                <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
              </a>
            </li>
          </ul>
          <ul className="footer-links">
            <li>
              <a href="/termsuse">
                <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
              </a>
            </li>
            <li>
              <a href="/disclaimer">
                <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social links */}
      <div className="footer-right">
      <div className="footer-social">
                            <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                            <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                           <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                            <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                          </div>
      </div>
      
      
    </div>

    

    {/* Right side fixed icons */}


    {/* Bottom text */}
  <div className="footer-bottom">
    <p className="marathi-text">
      © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
    </p>
  </div>

  </footer>

<ul className="right-side-icons">
    <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
         <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
       
      </ul>

    </>
  );
};

export default TermsUse;
